import React, {
  createContext,
  useCallback,
  useState,
  useEffect,
  useContext,
} from 'react';
import useDataApi from '../hooks/useDataApi';
import getIniUrl from '../utils/getIniUrl';

const IniContext = createContext();
const RefetchIniContext = createContext();

export function IniProvider({ children }) {
  const [fetchState, setDataUrl] = useDataApi({}, d => (window.iniData = d));
  const [version, setVersion] = useState(undefined);
  const [ini, setIni] = useState(null);

  const refetch = useCallback(() => {
    setDataUrl(getIniUrl(), {});
  }, [setDataUrl]);
  useEffect(() => {
    if (window.ini) {
      window.ini.then(x => setIni(x));
    } else {
      refetch();
    }
  }, [refetch]);
  useEffect(() => {
    if (!fetchState.isLoading && fetchState.data) {
      setIni(fetchState.data);
    }
  }, [fetchState.data, fetchState.isLoading]);

  //reload on version change
  useEffect(() => {
    if (version == null && ini) {
      setVersion(ini.general.version);
    } else {
      if (ini && version !== ini.general.version) {
        window.location.reload();
      }
    }
  }, [ini, version]);
  return ini ? (
    <IniContext.Provider value={ini}>
      <RefetchIniContext.Provider value={refetch}>
        {children}
      </RefetchIniContext.Provider>
    </IniContext.Provider>
  ) : null;
}

export default function useIni() {
  const ini = useContext(IniContext);
  if (!ini) throw new Error('useIni debe ser usado bajo IniProvider');
  return ini;
}

export function useRefetchIni() {
  return useContext(RefetchIniContext);
}
